import React, {useState, useEffect} from 'react';
import './Products.css';
import ProductLink from './Product-Link';
import { Link } from "react-router-dom";
import axios from 'axios'
import Menu from '../Menu/Menu'
import { useDesignMode } from '../DesignModeContext';
import { mockProducts } from '../mockData';
import Footer from '../Footer/Footer'


const Products = props => {
   const [products, setProducts] = useState([])
   const [productsSet, setProductsSet] = useState(false)
   const { isDesignMode } = useDesignMode();
   
    useEffect(() => {
        if (isDesignMode) {
            // Use mock data in design mode
            setProducts(mockProducts);
            setProductsSet(true);
        } else {
            // Fetch from API in live mode
            axios({
                url: "https://api.caigoycreations.com/products/getproducts?IsActive=true",
                method: "get"
              }).then(
                res => {
                    let tempProducts = res.data.data;
                    console.log(tempProducts)
                    setProducts(tempProducts);
                    setProductsSet(true)
                },
                err => {
                    console.log(err);
                  alert("connection to api failed, please upload again" + err.data);
                  
            });//end of await axios
        }
    }, [isDesignMode]);

    const CreateTable = () => {
        let Table = [];

        for (let i = 0; i < products.length;){
            let Row = [];
            for (let j = 0; j < 3 && i < products.length; j++, i++){
                
                Row.push(<ProductLink text={products[i].Name} pic={products[i].PictureUrl4} Id={i} Price={products[i].Price} IsSoldOut={products[i].IsSoldOut}  />);
            }
            Table.push(
                <div className="Row">
                    {Row}
                </div>);
        }

        return Table;
    }
    

    return (
        <div className="App">
            <Menu />
            <div className="BodyContent">
                <div className='ProductsSection'>
                    <h1 className='ProductsTitle'>Our <span>Products</span></h1>

                    { CreateTable()}
                    {
                        !productsSet &&
                        <h1>loading products...</h1>
                    }
                </div>
            </div>
            <Footer />
        </div>
    )
}


export default Products;
